import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './DownloadProgressModal.css';

/**
 * Modal that shows download progress with cancel option
 */
function DownloadProgressModal({
  isOpen,
  listTitle,
  phase,
  current,
  total,
  onCancel,
}) {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  // Handle ESC key to cancel
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const getPhaseText = () => {
    if (phase === 'fetching') return 'Fetching list data...';
    if (phase === 'photos') return 'Saving places...';
    if (phase === 'complete') return 'Saved!';
    return 'Preparing...';
  };

  const getProgress = () => {
    if (phase === 'fetching' || !total) return null;
    return Math.round((current / total) * 100);
  };

  const progress = getProgress();

  return ReactDOM.createPortal(
    <div className="download-modal-overlay">
      <div className="download-modal">
        <div className="download-modal-header">
          <DownloadIcon />
          <h3>Saving for Offline</h3>
        </div>

        <div className="download-modal-content">
          <p className="download-list-title">{listTitle}</p>
          <p className="download-phase-text">{getPhaseText()}</p>

          {progress !== null && (
            <div className="download-progress-container">
              <div className="download-progress-bar">
                <div
                  className="download-progress-fill"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <span className="download-progress-label">
                {current} of {total} places
              </span>
            </div>
          )}

          {phase === 'fetching' && (
            <div className="download-spinner-container">
              <div className="download-spinner" />
            </div>
          )}
        </div>

        <div className="download-modal-footer">
          <button
            className="download-cancel-btn"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

const DownloadIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

export default DownloadProgressModal;
